import React, {FC} from "react";
import {Link} from "@material-ui/core";
import logo_green from "../logo_green.png";

const DesktopHeaderLink: FC<{ to: string; label: string }> = ({to, label}) => (
    <Link
        href={to}
        color="secondary"
        style={{fontSize: 17, fontWeight: 600}}
        target={"_blank"}
    >
        {label}
    </Link>
);

export const OrderEngineDesktopHeader: FC = () => {
    return (
        <div style={{width: "100%"}}>
            <div style={{
                width: "80%",
                margin: "auto",
                display: "flex",
                alignItems: "center"
            }}>
                <img
                    style={{maxHeight: 100}}
                    alt="logo"
                    src={logo_green}
                />
                <div
                    style={{
                        display: "flex",
                        justifyContent: "space-around",
                        flex: 1,
                        paddingLeft: 80
                    }}
                >
                    <DesktopHeaderLink
                        label="Heckenschnitt"
                        to="https://www.diefleissigenenkel.de/heckenschnitt/"
                    />
                    <DesktopHeaderLink
                        label="Gartenhilfe"
                        to="https://www.diefleissigenenkel.de/gartenhilfe/"
                    />
                    <DesktopHeaderLink
                        label="Vertikutieren"
                        to="https://www.diefleissigenenkel.de"
                    />
                    <DesktopHeaderLink
                        label="Obstbaumschnitt"
                        to="https://www.diefleissigenenkel.de/obstbaumschnitt/"
                    />
                    <DesktopHeaderLink
                        label="Kontakt"
                        to="https://www.diefleissigenenkel.de/kontakt/"
                    />
                </div>
            </div>
        </div>
    )
}
